<template>
    <main id="dashboard">
        <div class="container mx-auto">
            <div class="breadcumb">
                <div class="breadcumb__left">
                    <p class="breadcumb__title">Products</p>
                </div>
                <div class="breadcumb__right">
                    <date-picker prefix-class="xmx" v-model="value" type="date" range placeholder="Select date range"></date-picker>
                </div>
            </div>

            <div class="flex flex-wrap -mx-3">
                <div class="px-3 pb-6 w-full sm:w-1/3">
                    <div class="card card--overview">
                        <h3 class="card--overview__val">0</h3>
                        <div class="card--overview__label">
                            <i class="fa fa-shopping-cart"></i>
                            <span>Total Products</span>
                        </div>
                    </div>
                </div>
                <div class="px-3 pb-6 w-full sm:w-1/3">
                    <div class="card card--overview">
                        <h3 class="card--overview__val">0</h3>
                        <div class="card--overview__label">
                            <i class="fa fa-shopping-cart"></i>
                            <span>Total Leads</span>
                        </div>
                    </div>
                </div>
                <div class="px-3 pb-6 w-full sm:w-1/3">
                    <div class="card card--overview">
                        <h3 class="card--overview__val">0</h3>
                        <div class="card--overview__label">
                            <i class="fa fa-credit-card"></i>
                            <span>Total Paid</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-wrapper">

                <div class="flex flex-wrap justify-between items-center">

                    <div class="table-action flex flex-wrap -mx-2 w-full md:w-auto pb-4">
                        <div class="px-1 w-auto mb-3">
                            <button class="btn btn-round-less btn-xxs btn-base">
                                <i class="fas fa-trash-alt"></i>
                                Hapus
                            </button>
                        </div>

                        <div class="px-1 w-auto mb-3">
                            <div class="btn-dd">
                                <span class="btn btn-round-less btn-xxs btn-base btn-ii">
                                    Action
                                    <i class="fas fa-chevron-down"></i>
                                </span>
                                <ul>
                                    <li><a href="#!">Option 1</a></li>
                                    <li><a href="#!">Option 2</a></li>
                                    <li><a href="#!">Option 3</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="form-set w-full md:w-auto">
                        <!-- <label>
                            <strong>Harga Reguler</strong>
                        </label> -->
                        <input type="search" placeholder="Cari">
                    </div>
                </div>

                <table class="table">
                    <thead>
                    <tr>
                        <th>
                            <label class="cbx-set _center">
                                <input type="checkbox">
                                <div class="_box"></div>
                            </label>
                        </th>
                        <th class="hidden sm:table-cell"></th>
                        <th>Name</th>
                        <th class="hidden sm:table-cell">Price</th>
                        <th class="hidden sm:table-cell">Lead</th>
                        <th class="hidden sm:table-cell">Paid</th>
                        <th class="hidden sm:table-cell">Paid Ratio</th> 
                    </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="align-top sm:align-middle">
                                <label class="cbx-set _center">
                                    <input type="checkbox">
                                    <div class="_box"></div>
                                </label>
                            </td>
                            <td class="hidden sm:table-cell">
                                <img src="~@/assets/img/empty.svg" alt="Product Image">
                            </td>
                            <td class="sm:hidden">
                                <div class="_wrapper">
                                    <div class="_cont">
                                        <img src="~@/assets/img/empty.svg" alt="Product Image">
                                    </div>
                                </div>
                                <div class="_wrapper">
                                    <div class="_cont">
                                        <a class="main-link" href="#!">Kemeja Kemko</a>
                                    </div>
                                </div>
                                <div class="_wrapper">
                                    <div class="_title">Price</div>
                                    <div class="_cont">Rp 200.000</div>
                                </div>
                                <div class="_wrapper">
                                    <div class="_title">Lead</div>
                                    <div class="_cont">0</div>
                                </div>
                                <div class="_wrapper">
                                    <div class="_title">Paid</div>
                                    <div class="_cont">0</div>
                                </div>
                                <div class="_wrapper">
                                    <div class="_title">Paid Ratio</div>
                                    <div class="_cont">0%</div>
                                </div>
                                <div class="_wrapper">
                                    <div class="_cont">
                                        <a class="btn btn-w-xs btn-xs btn-primary mb-4" href="checkout.html" target="_blank"><i class="fa fa-external-link-alt"></i> Checkout</a><br>
                                        <button class="btn btn-w-xs btn-xs btn-error mb-4"><i class="fa fa-trash"></i> Hapus</button>
                                    </div>
                                </div>
                            </td>
                            <td class="hidden sm:table-cell">
                                <a class="main-link" href="#!">Kemeja Kemko</a>
                                <div class="sub-content">
                                    <a href="checkout.html" target="_blank"><i class="fa fa-external-link-alt"></i> Checkout</a>
                                    <button class="_error ml-4"><i class="fa fa-trash"></i> Hapus</button>
                                </div>
                            </td>
                            <td class="hidden sm:table-cell">Rp 200.000</td>
                            <td class="hidden sm:table-cell text-center">0</td>
                            <td class="hidden sm:table-cell text-center">0</td>
                            <td class="hidden sm:table-cell text-center">0%</td>
                        </tr>
                        
                        <tr>
                            <td class="align-top sm:align-middle">
                                <label class="cbx-set _center">
                                    <input type="checkbox">
                                    <div class="_box"></div>
                                </label>
                            </td>
                            <td class="hidden sm:table-cell">
                                <img src="~@/assets/img/empty.svg" alt="Product Image">
                            </td>
                            <td class="sm:hidden">
                                <div class="_wrapper">
                                    <div class="_cont">
                                        <img src="~@/assets/img/empty.svg" alt="Product Image">
                                    </div>
                                </div>
                                <div class="_wrapper">
                                    <div class="_cont">
                                        <a class="main-link" href="#!">Kemeja Kemko</a>
                                    </div>
                                </div>
                                <div class="_wrapper">
                                    <div class="_title">Price</div>
                                    <div class="_cont">Rp 200.000</div>
                                </div>
                                <div class="_wrapper">
                                    <div class="_title">Lead</div>
                                    <div class="_cont">0</div>
                                </div>
                                <div class="_wrapper">
                                    <div class="_title">Paid</div>
                                    <div class="_cont">0</div>
                                </div>
                                <div class="_wrapper">
                                    <div class="_title">Paid Ratio</div>
                                    <div class="_cont">0%</div>
                                </div>
                                <div class="_wrapper">
                                    <div class="_cont">
                                        <a class="btn btn-w-xs btn-xs btn-primary mb-4" href="checkout.html" target="_blank"><i class="fa fa-external-link-alt"></i> Checkout</a><br>
                                        <button class="btn btn-w-xs btn-xs btn-error mb-4"><i class="fa fa-trash"></i> Hapus</button>
                                    </div>
                                </div>
                            </td>
                            <td class="hidden sm:table-cell">
                                <a class="main-link" href="#!">Kemeja Kemko</a>
                                <div class="sub-content">
                                    <a href="checkout.html" target="_blank"><i class="fa fa-external-link-alt"></i> Checkout</a>
                                    <button class="_error ml-4"><i class="fa fa-trash"></i> Hapus</button>
                                </div>
                            </td>
                            <td class="hidden sm:table-cell">Rp 200.000</td>
                            <td class="hidden sm:table-cell text-center">0</td>
                            <td class="hidden sm:table-cell text-center">0</td>
                            <td class="hidden sm:table-cell text-center">0%</td>
                        </tr>
                        
                        <tr>
                            <td class="align-top sm:align-middle">
                                <label class="cbx-set _center">
                                    <input type="checkbox">
                                    <div class="_box"></div>
                                </label>
                            </td>
                            <td class="hidden sm:table-cell">
                                <img src="~@/assets/img/empty.svg" alt="Product Image">
                            </td>
                            <td class="sm:hidden">
                                <div class="_wrapper">
                                    <div class="_cont">
                                        <img src="~@/assets/img/empty.svg" alt="Product Image">
                                    </div>
                                </div>
                                <div class="_wrapper">
                                    <div class="_cont">
                                        <a class="main-link" href="#!">Kemeja Kemko</a>
                                    </div>
                                </div>
                                <div class="_wrapper">
                                    <div class="_title">Price</div>
                                    <div class="_cont">Rp 200.000</div>
                                </div>
                                <div class="_wrapper">
                                    <div class="_title">Lead</div>
                                    <div class="_cont">0</div>
                                </div>
                                <div class="_wrapper">
                                    <div class="_title">Paid</div>
                                    <div class="_cont">0</div>
                                </div>
                                <div class="_wrapper">
                                    <div class="_title">Paid Ratio</div>
                                    <div class="_cont">0%</div>
                                </div>
                                <div class="_wrapper">
                                    <div class="_cont">
                                        <a class="btn btn-w-xs btn-xs btn-primary mb-4" href="checkout.html" target="_blank"><i class="fa fa-external-link-alt"></i> Checkout</a><br>
                                        <button class="btn btn-w-xs btn-xs btn-error mb-4"><i class="fa fa-trash"></i> Hapus</button>
                                    </div>
                                </div>
                            </td>
                            <td class="hidden sm:table-cell">
                                <a class="main-link" href="#!">Kemeja Kemko</a>
                                <div class="sub-content">
                                    <a href="checkout.html" target="_blank"><i class="fa fa-external-link-alt"></i> Checkout</a>
                                    <button class="_error ml-4"><i class="fa fa-trash"></i> Hapus</button>
                                </div>
                            </td>
                            <td class="hidden sm:table-cell">Rp 200.000</td>
                            <td class="hidden sm:table-cell text-center">0</td>
                            <td class="hidden sm:table-cell text-center">0</td>
                            <td class="hidden sm:table-cell text-center">0%</td>
                        </tr>
                        
                    </tbody>
                </table>
            </div>

            <div class="table-wrapper">

                <div class="flex flex-wrap justify-between items-center">

                    <div class="table-action flex flex-wrap -mx-2 w-full md:w-auto pb-4">
                        <div class="px-1 w-auto mb-3">
                            <button class="btn btn-round-less btn-xxs btn-base">
                                <i class="fas fa-trash-alt"></i>
                                Hapus
                            </button>
                        </div>

                        <div class="px-1 w-auto mb-3">
                            <div class="btn-dd">
                                <span class="btn btn-round-less btn-xxs btn-base btn-ii">
                                    Action
                                    <i class="fas fa-chevron-down"></i>
                                </span>
                                <ul>
                                    <li><a href="#!">Option 1</a></li>
                                    <li><a href="#!">Option 2</a></li>
                                    <li><a href="#!">Option 3</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="form-set w-full md:w-auto">
                        <!-- <label>
                            <strong>Harga Reguler</strong>
                        </label> -->
                        <input type="search" placeholder="Cari">
                    </div>
                </div>

                <table class="table">
                    <thead>
                    <tr>
                        <th>
                            <label class="cbx-set _center">
                                <input type="checkbox">
                                <div class="_box"></div>
                            </label>
                        </th>
                        <th class="hidden sm:table-cell"></th>
                        <th>Name</th>
                        <th class="hidden sm:table-cell">Price</th>
                        <th class="hidden sm:table-cell">Lead</th>
                        <th class="hidden sm:table-cell">Paid</th>
                        <th class="hidden sm:table-cell">Paid Ratio</th> 
                    </tr>
                    </thead>
                </table>
                <div class="table-empty">
                    <i class="fa fa-info-circle"></i> Belum ada data
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import $ from 'jquery'
    import DatePicker from 'vue2-datepicker';

    export default {
        components: { DatePicker },
        data() {
            return {
            value: [new Date(2020, 11, 1), new Date(2020, 11, 7)],
            };
        },
        mounted () {

            $('th input[type="checkbox"]').click(function(){
                if ($(this).prop('checked')) {
                    $(this).parents('table').find('tbody tr td input[type="checkbox"]').prop('checked', true);
                } else {
                    $(this).parents('table').find('tbody tr td input[type="checkbox"]').prop('checked', false);
                }
            });
        }
    }
</script>

<style lang="sass" scoped>
@import ~@/sass/main

.table-wrapper
    position: relative

    .table-action
        top: 44px
        left: 16px

table
    thead
        tr
            th
                    
                &:nth-child(3),
                &:nth-child(4)
                    text-align: left
                    
    
    tbody
        tr
            td
                &:nth-child(1)
                    width: 40px
                    
                &:nth-child(2)
                    width: 72px


                &:nth-child(3),
                &:nth-child(4)

                img
                    background-color: mix($color-gray, black, 90%)
                    border-radius: 4px

                .sub-content
                    overflow: hidden
                    height: 0
                    opacity: 0
                    margin-top: 4px
                    transition: all .2s ease-in-out .2s, opacity .2s ease-in-out

            &:hover

                td
                    .sub-content
                        opacity: 1
                        height: 20px
                        transition: all .2s ease-in-out, opacity .2s ease-in-out .2s
</style>